import { queryClient } from '@/queryClient';
import { API_PRODUTO_GET_KEY } from '../api/apiProdutoGet';
import { API_PRODUTO_TOTAIS_POR_TIPO_KEY } from '../api/apiProdutoTotaisPorTipo';

export function invalidateProdutoQueries(): void {
    void queryClient.invalidateQueries({ queryKey: [API_PRODUTO_GET_KEY] });
    void queryClient.invalidateQueries({ queryKey: [API_PRODUTO_TOTAIS_POR_TIPO_KEY] });
}
